module.exports = __webpack_public_path__ + "img/img10.d227fcf0.svg";